exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the Course module should live here.\n * Import as neede like so:\n * ...\n * import courseStyles from 'courseModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"course-item\">\n * ...\n */\n\n.modules-course-___courseModuleStyles__course-item___1yMw0 {\n  \n}\n", ""]);

// exports
exports.locals = {
	"course-item": "modules-course-___courseModuleStyles__course-item___1yMw0"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/course/courseModuleStyles.css
// module id = 1347
// module chunks = 1